import { forwardRef, useContext } from 'react';
import styled from '@emotion/styled';
import { sectionStyles } from '../css/styles';
import theme from '../theme';
import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import SliderComponent from './SliderComponent';
import { FadeInSection } from '../hooks/FadeInSection';
import { Link } from 'react-router-dom';

//export default function Section3() {
const Section3 = forwardRef((props, ref) => {

    const { selectLanguage } = useContext(LangContext);
    const { isMobile, toolbarHeight } = useContext(DeviceContext);    
  
    const Section3 = styled.section`    
        ${sectionStyles}
        height:1200px;
        background-size: cover;
        background-image: url('/images/bg/section3_bg_pc.png');
        text-align:center;
        margin:auto;
        color:white;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap:34px;

        //${theme.breakpoints.xl} {
        //    background-image: url('/images/bg/section3_bg_pc.png');
        //    background-size: cover; 
        //    background-position: center center;
        //    background-repeat: no-repeat;
        //}

        ${theme.breakpoints.xl_1920} {
            gap:26px; 
            height:900px;
            background-image: url('/images/bg/section3_bg_pc_1920.png');            
        }   
        
        ${theme.breakpoints.xl} {
            gap:0px;
            //padding-top:${({ selectLanguage }) => selectLanguage === 'ENGLISH' ? '0' : '50px'};
            //height:${({ selectLanguage }) => selectLanguage === 'ENGLISH' ? '780px' : '780px'};
            
            height:100%;
            min-height: 100%;
            min-heght: -webkit-fill-available;

            background-image: url('/images/bg/content_bg_mobile_3.png');
            background-size: cover; 
            background-position: center center;
            background-repeat: no-repeat;
            position:relative;
        }  
    `;

    const Title1 = styled.div`
        font-size:1.875rem;
        color:white;
        opacity:.2;
        // margin-bottom: 30px;
        display:flex;
        align-items:center;
        justify-content:center;
        gap:6px;

        ${theme.breakpoints.xl_1920} {
            font-size:20px;
        }

        ${theme.breakpoints.xl} {
            margin-top:50px;
            font-size:14px;             
        }
    `;

    const TitleNumber = styled.span`
         font-size:4.375rem;

        ${theme.breakpoints.xl_1920} {
            font-size:50px;
        }

        ${theme.breakpoints.xl} {
            font-size:24px;
            line-height:165%;
        }
    `;

    const Title2 = styled.div`
        font-size:4.125rem;
        color:white;

        ${theme.breakpoints.xl_1920} {
            font-size:52px;
        }

        ${theme.breakpoints.xl} {
            margin:0 0 14px 0;            
            font-size:28px;
        }
    `;

    const Text = styled.div`
        font-size: 1.75rem;
        font-family: "Gmarket Sans";
        line-height: 165%; 
        color:white;
        opacity: .8;
        white-space: pre-line;

        ${theme.breakpoints.xl_1920} {
            font-size:24px;
        }

        ${theme.breakpoints.xl} {            
            font-size: 14px;
            font-weight: 500;
            line-height: 150%;
        }
    `;

    const ButtonBox = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:20px;

        ${theme.breakpoints.xl} {            
            flex-direction:column;
            gap:10px;
            margin-bottom :14px;
        }

    `;

    const ButtonBox1 = styled.div`
        //display: flex;
        //width: 460px;
        //height: 76px;        
        //justify-content: center;
        //align-items: center;        
        //font-size: 34px;
        //border-radius: 6px;
        //border: 2px solid #FFF;
        //background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
        //box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);        

        img{
            width: 400px;
            height:100px;            

            transition:all 0.2s ease;
            &:active{                
                display:inline-block;
                scale: 1.1;
            }

        }

        ${theme.breakpoints.xl_1920} {
           // width: 376px;
           // font-size: 28px;
        }

        ${theme.breakpoints.xl} {            
            img{
                margin-top:14px;
                width:260px;
                height:60px;
            }
        }
    `;

    const ButtonBox2 = styled.div`
        img{
            width: 400px;
            height:100px;

            transition:all 0.2s ease;
            &:active{                
                display:inline-block;
                scale: 1.1;
            }
        }
        
        //width: 460px;
        //height: 76px;        
        //display: flex;
        //justify-content: center;
        //align-items: center;        
        //font-size: 34px;        
        //gap:20px;        
        //border-radius: 6px;
        //border: 2px solid #FFF;
        //background: var(--Red-400, #F90052);
        //box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);        
//
        //div:last-child{
        //    display:flex;
        //    align-items:center;
        //    justify-content:center;
        //}
//
        //${theme.breakpoints.xl_1920} {
        //    width: 376px;
        //    font-size: 28px;
        //}

        ${theme.breakpoints.xl} {            
            img{
                width:260px;
                height:60px;
            }
        }
    `;

    const MetodiumBox = styled.div`
        ${theme.breakpoints.xl} {
            position: relative;
            margin:70px 0 50px 0;
        }
    `;

    const MetodiumFrontBox = styled.div`
        display: flex;
        width: 269px;
        height: 342px;
        padding: 2px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        border-radius : 24px;
        backdrop-filter: blur(10px);        
        // border-radius: 999px 999px 0px 0px;                
        // position:absolute;        
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);        
        // z-index: 2;

        background-image:linear-gradient(black 70%,rgba(0, 0, 0, 0.00) 100%),linear-gradient(0deg, transparent 0%, white 100%);
        background-origin: border-box;
        background-clip: content-box, border-box;

        img{
            // margin-top:30px;
            width:148px;
        }
        
        ${theme.breakpoints.xl_1920} {
            width: 269px;
            font-size: 28px;
        }

        ${theme.breakpoints.xl} {            
            width: 140px;  
            height:228px;

            border-radius: 999px 999px 0px 0px;                
            position:absolute;        
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);        
            z-index: 2;


            img{
                padding-top:10px;
                width:67.2px;
            }
        }
    `;

    const MetodiumFrontToken = styled.div`
        display: flex;
        padding: 0px 28px;
        //font-size: 2.5rem;
        font-size: 24px;
        justify-content: center;
        align-items: center;
        color: var(--Red-400, #F90052);

        gap: 20px;

        //border-radius: 50px;
        //background: var(--Red-400, #F90052);
        //box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);               
        margin-top:28.2px;

        ${theme.breakpoints.xl_1920} {            
            margin-top:12.6px;
            font-size: 24px;
        }

        ${theme.breakpoints.xl} {
            font-size: 12px;
            padding:0;
            line-height: 165%; 
        }
    `;

    const MetodiumFrontTitle = styled.div`
        line-height: 165%;                  
        font-size: 32px;
        margin-bottom:8px;
        
        ${theme.breakpoints.xl_1920} {         
            font-size: 32px;
        }

        ${theme.breakpoints.xl} {
            font-size: 16px;
        }
    `;

    const MetodiumCount = styled.div`
        width:160px;
        height:66px;

        background-image: url('/images/icon/button_bg_red.png');
        background-size: cover; 
        background-position: center center;
        background-repeat: no-repeat;
        
        display: flex;        
        justify-content: center;
        align-items: center;        
        line-height: 165%;
        font-size:32px;        
        border-radius: 12px;        

        ${theme.breakpoints.xl_1920} {     
            font-size:32px;
        }

        ${theme.breakpoints.xl} {  
            width:100px;
            height:40px;          
            font-size:18px;
        }
    `;

    const MetodiumFrontHr = styled.hr`
        width: 300px;
        height: 2px;
        background-color: white;
        margin:0;
    `;

    const MetodiumFrontCount = styled.div`        
        //text-align: center;
        font-size: 32px;
        line-height: 165%;
        //display: flex;
        //width: 108px;
        //padding: 0px 39px;
        //justify-content: center;
        //align-items: center;
        //gap: 10px;
//
        //border-radius: 12px;
        //background: var(--Red-400, #F90052);
        //gap:0;
//
        //${theme.breakpoints.xl_1920} {
        //    width: 108px;
        //    padding: 0 39px;
        //    font-size: 32px;
        //}

        width:160px;
        height:50px;
        margin-left:-5px;

        background-image: url('/images/icon/button_bg_red.png');
        background-size: cover; 
        background-position: center center;
        background-repeat: no-repeat;

        ${theme.breakpoints.xl} {
            width:100px;
            height:auto;
            margin-left:-5px;
            font-size:18px;
            font-weight: 400;
            line-height: 40px 
        }
    `;

    const MetodiumBackBox = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:180px;

        ${theme.breakpoints.xl} {
            gap:20px;            
        }
    `;

    const MetodiumBackBoxBlur = styled.div`
        display: flex;
        width: 272px;
        height: 292px;
        padding: 4px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 24px;
        flex-shrink: 0;

        border-radius: 999px 999px 0px 0px;
        /* border: 4px solid #FFF; */
        opacity: 0.5;
                                                                                
        background-image:linear-gradient(black 70%,rgba(0, 0, 0, 0.00) 100%),linear-gradient(0deg, transparent 0%, white 100%);
        background-origin: border-box;
        background-clip: content-box, border-box;

        img{
            padding:10.8px;
            width: 98px;
            display:flex;
            align-items:center;
            justify-content:center;
        }

        ${theme.breakpoints.xl} {
            width: 118px;
            height: 106px;
            padding: 1px;

            img{
                width: 49.2px;
                padding:5.4px;
            }
        }

    `;

  return (
    <Section3 ref={ref} toolbarHeight={toolbarHeight} selectLanguage={selectLanguage}>
        <SliderComponent/>        
    </Section3>
  )
});

export default Section3;